import React from 'react';

export const SvgDispAllEn = (props) => (
  <svg
    overflow='hidden'
    viewBox='0 0 1236 653'
    xmlns='http://www.w3.org/2000/svg'
    width='100%'
    height='100%'
    {...props}
  >
    <defs>
      <clipPath id='DispAll_en_svg__a'>
        <path d='M131 1494h1239v655H131z' />
      </clipPath>
    </defs>
    <g
      transform='matrix(.99793 0 0 .99758 -130.94 -1490.6)'
      clipPath='url(#DispAll_en_svg__a)'
    >
      <path
        d='M133.5 1604.8c0-59.84 48.503-108.34 108.34-108.34h1017.3c59.84 0 108.34 48.5 108.34 108.34v433.32c0 59.84-48.5 108.34-108.34 108.34H241.84c-59.832 0-108.34-48.5-108.34-108.34z'
        fillRule='evenodd'
        stroke='#4472c4'
        strokeMiterlimit={8}
        strokeWidth={4.583}
      />
    </g>
    <g
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 204.25
      }}
      aria-label='DISPLAYALL'
    >
      <path d='M270.82 194.8q0 20.49-9.358 36.745-9.359 16.156-23.643 24.825-10.738 6.502-23.544 9.063-12.807 2.561-30.342 2.561h-51.718v-146.68h53.196q17.93 0 30.932 3.054 13.003 2.955 21.87 8.472 15.17 9.26 23.84 25.022 8.767 15.663 8.767 36.942zm-39.109-.296q0-14.48-5.32-24.726-5.22-10.344-16.648-16.156-5.812-2.856-11.92-3.841-6.009-1.084-18.224-1.084h-9.555v91.812h9.555q13.496 0 19.801-1.182 6.305-1.28 12.314-4.532 10.344-5.91 15.171-15.762 4.827-9.95 4.827-24.529zM378.98 267.99h-85.901v-26.007h24.037v-94.669h-24.037v-26.007h85.901v26.007h-24.037v94.669h24.037zM527.24 221.89q0 21.672-18.422 35.267-18.323 13.496-49.846 13.496-18.224 0-31.819-3.152-13.496-3.251-25.317-8.177v-35.168h4.137q11.723 9.359 26.204 14.383 14.58 5.024 27.977 5.024 3.448 0 9.063-.59 5.615-.592 9.162-1.971 4.334-1.773 7.093-4.433 2.856-2.66 2.856-7.88 0-4.828-4.137-8.276-4.039-3.546-11.92-5.418-8.275-1.97-17.535-3.645-9.161-1.773-17.239-4.433-18.52-6.009-26.696-16.254-8.078-10.344-8.078-25.613 0-20.49 18.323-33.395 18.422-13.003 47.285-13.003 14.481 0 28.568 2.857 14.186 2.758 24.53 6.994v33.79h-4.04q-8.866-7.093-21.77-11.822-12.807-4.827-26.205-4.827-4.728 0-9.457.69-4.63.591-8.964 2.364-3.842 1.478-6.6 4.532-2.759 2.955-2.759 6.797 0 5.812 4.433 8.964 4.433 3.054 16.747 5.616 8.078 1.674 15.466 3.25 7.487 1.577 16.057 4.335 16.845 5.517 24.825 15.072 8.078 9.457 8.078 24.628zM674.22 167.61q0 9.851-3.448 19.308-3.448 9.358-9.851 15.762-8.767 8.669-19.604 13.102-10.738 4.433-26.795 4.433h-23.544v47.778H553.15v-146.68h62.259q13.989 0 23.544 2.463 9.654 2.364 17.042 7.191 8.866 5.812 13.496 14.875 4.729 9.063 4.729 21.771zm-39.109.887q0-6.207-3.35-10.64-3.349-4.53-7.782-6.304-5.91-2.364-11.526-2.561-5.615-.296-14.974-.296h-6.502v43.936h10.836q9.654 0 15.86-1.182 6.305-1.182 10.541-4.729 3.645-3.152 5.222-7.486 1.674-4.433 1.674-10.738zM806.82 267.99h-105.8V121.31h37.828v118.31h67.972zM965.12 267.99h-39.109l-10.147-29.652h-54.378l-10.147 29.652h-38.124l54.181-146.68h43.542zm-58.417-56.545-18.027-52.605-18.027 52.605zM1115.3 121.31l-54.082 89.94v56.742h-37.828v-54.969l-54.969-91.714h42.951l31.72 56.742 30.637-56.742zM562.21 520.18h-39.109l-10.147-29.652h-54.378l-10.147 29.652h-38.124l54.181-146.68h43.542zm-58.417-56.545-18.027-52.605-18.027 52.605zM689.1 520.18H583.3V373.5h37.828v118.31H689.1zM817.65 520.18h-105.8V373.5h37.828v118.31h67.972z' />
    </g>
  </svg>
);
